import { render, staticRenderFns } from "./AccordionFaq.vue?vue&type=template&id=3c55b041&scoped=true"
import script from "./AccordionFaq.vue?vue&type=script&lang=js"
export * from "./AccordionFaq.vue?vue&type=script&lang=js"
import style0 from "./AccordionFaq.vue?vue&type=style&index=0&id=3c55b041&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55b041",
  null
  
)

export default component.exports